import { type ControlPosition, MapControl } from '@vis.gl/react-google-maps'
import React from 'react'

type DistanceControlProps = {
  controlPosition: ControlPosition
  distance: number
  onDistanceChange: (zoom: number) => void
}

export const DistanceControl = ({
  controlPosition,
  distance,
  onDistanceChange,
}: DistanceControlProps) => {
  return (
    <MapControl position={controlPosition}>
      <div
        style={{
          margin: '10px',
					marginBottom: '90px',
          padding: '1em',
          background: 'rgba(255,255,255,0.8)',
          display: 'flex',
          textAlign: 'center',
          flexFlow: 'column nowrap',
        }}
      >
        <label htmlFor={'distance'}>{`Distancia: ${distance}km`}</label>
        <input
          id={'distance'}
          type={'range'}
          min={10}
          max={50}
          step={'10'}
          value={distance}
          onChange={(ev) => onDistanceChange(ev.target.valueAsNumber)}
        />
      </div>
    </MapControl>
  )
}
